// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const LeafMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M11.6663 9.16667C9.64788 11.0973 7.62941 15.8333 7.62941 15.8333C7.62941 15.8333 6.21651 11.8168 3.33301 10.2783" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.4135 4.60363L16.7685 8.2902C16.9987 10.6818 15.2056 12.8111 12.8141 13.0414C10.4674 13.2674 8.34165 11.5521 8.11565 9.20553C7.88973 6.85886 9.60882 4.77336 11.9555 4.54741L15.8861 4.16893C16.1518 4.14335 16.3879 4.33797 16.4135 4.60363Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
